import React, { useEffect, useState } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PdfFile from "./PdfFile";
import { useDispatch, useSelector } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import useDashboardDataForPDF from "./useDashboardDataForPDF";

const DownloadButton = ({
  // portfolioData,
  // schemeDocData,
  selectedSchemeOptions,
  investorDetails
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false); // To manage loading state for PDF generation
  const { schemeFundPerformanceDataForPDF,aumDataForSpecificScheme,investorSchemeDetails,schemeOverviewDataForPDF,schemePortfolioData,schemeSectorAllocationData,schemeDocuments } = useDashboardDataForPDF(selectedSchemeOptions);

  // useEffect(() => {
  //   // Set loader to true when the component is mounted
  //   dispatch(loaderSet(true));
  // }, [dispatch]);

  const handleLoader = (loading) => {
    // Update the loader state based on the loading status
    if (loading) {
      setIsLoading(true);  // Show the loader
      dispatch(loaderSet(true));  // Optional: Trigger Redux loader state
    } else {
      setIsLoading(false);  // Hide the loader when loading is complete
      dispatch(loaderSet(false));  // Optional: Trigger Redux loader state
    }
  };

  return (
    <>
      {schemeFundPerformanceDataForPDF && schemeOverviewDataForPDF  && schemePortfolioData && schemeSectorAllocationData ? (
        <PDFDownloadLink
          document={
            <PdfFile
              selectedSchemeOptions={selectedSchemeOptions}
              overviewData={schemeOverviewDataForPDF}
              tableData={schemeFundPerformanceDataForPDF}
              investorDetails={investorDetails}
              aumDataForSpecificScheme={aumDataForSpecificScheme}
              investorSchemeDetails={investorSchemeDetails}
              schemePortfolioData={schemePortfolioData}
              schemeSectorAllocationData={schemeSectorAllocationData}
              schemeDocData={schemeDocuments}
            />
          }
          fileName="Investor.pdf"
          onClick={()=>{
            dispatch(loaderSet(true))
            setTimeout(() => {
              dispatch(loaderSet(false))
            }, 1000);
          }}
        >
          {({ loading }) => {
            // Manage loading state
            handleLoader(loading);
            return loading ? "Download PDF" : "Download PDF"; // Show loader or button
          }}
        </PDFDownloadLink>
      ) : (
        "...Procesing PDF" // Show loading message if data is still being fetched
      )}

      {/* {isLoading && <div>Loading...</div>}  Display loading indicator */}
    </>
  );
};

export default DownloadButton;